module.exports = __webpack_public_path__ + "img/task-6-g.9bf1b8b1.png";